module.exports = __webpack_public_path__ + "img/ufo.7d405b29.png";